import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { ISessionProperty, ISessionState } from '../../interfaces/session';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faSquareArrowUpRight
} from '@fortawesome/pro-regular-svg-icons';

const HeaderSessionText = () => {

    const sessionState: ISessionState = useSelector(
        ({ SessionState }: any) => SessionState
    );

    const { Session } = sessionState || {};
    const { SessionID, SessionType } = Session || {};


    const [headerName, setHeaderName] = useState<string>('');
    const [headerText, setHeaderText] = useState<string>('');
    const [headerURL, setHeaderURL] = useState<string>('');

    useEffect(() => {

        const { Org, Properties } = sessionState;

        const websiteURL = Properties?.length ? Properties[0].WebsiteURL : '';

        if (Org) {
            setHeaderName(Org.Name);
            setHeaderText('');
            setHeaderURL(`${websiteURL}/provider/${Org.Slug}`);
        } else if ((Properties || []).length > 1) {
            setHeaderName(Properties[0].OrgName);
            setHeaderText('A selection of facilities from');
            setHeaderURL(`${websiteURL}/provider/${Properties[0].OrgSlug}`);
        } else if ((Properties || []).length === 1) {
            setHeaderName(Properties[0].Name);
            setHeaderText('');
            setHeaderURL(`${websiteURL}/${Properties[0].StateSlug}/${Properties[0].CitySlug}/${Properties[0].Slug}/`);
        } else {
            setHeaderText('');
            setHeaderURL('');
        }

    }, [SessionID, SessionType ]);

    const renderSubscriptionLink = () => {
        const { Org, Properties } = sessionState || {};

        if (!Properties?.[0]?.WebsiteURL) {
            return;
        }

        const showAsPremium = Org ? Org.IsPremium : Properties.every((property: ISessionProperty) => property.IsPremium);

        return (
            <>
                <div className="whitespace-nowrap leading-tight py-1 px-2 bg-brand_faint-blue rounded-md">
                    <span>Current Subscription:</span> <a className="link" href={`${Properties[0].WebsiteURL}/subscribe/`} target='_blank' rel="noreferrer">{ showAsPremium ? 'Premium' : 'Basic'}</a>
                </div>
            </>
        );
    };

    return (
        <>
            {
                headerText ?
                <span className="text-2xs text-brand_grey-medium leading-tight block xl:text-xs">
                    { headerText }
                </span>: null
            }
            <h4 className="font-semibold leading-tight text-base block my-0.5 lg:text-lg xl:text-xl">
                { headerName }
            </h4>
            <div className="flex items-center mt-1 text-2xs xl:text-xs">
                {
                    headerURL ?
                    <a className="link me-2" href={headerURL} target="_blank" rel="noreferrer" title="Visit on nursinghomes.com">
                        <FontAwesomeIcon icon={faSquareArrowUpRight} className="text-lg relative top-px xl:me-1" /><span className="hidden xl:inline-block">View on nursinghomes.com</span>
                    </a>: null
                }
                { renderSubscriptionLink() }
            </div>
        </>
    );
};

export default HeaderSessionText;
